import accounting from 'accounting';


accounting.settings.currency.format = {
  pos : "%s%v",   // for positive values, eg. "$ 1.00" (required)
  neg : "(%s%v)", // for negative values, eg. "$ (1.00)" [optional]
  zero: ""  // for zero values, eg. "$  --" [optional]
};


/**
 * Format money default
 * @param val
 */
function fm(val, cur) {
  let symbol = (!cur) ? '$' : cur + ' '
  return accounting.formatMoney(val, symbol, 2);
}

export {
  fm
};


// WEBPACK FOOTER //
// ./src/services/money.js